import { IAccountingFileStatus } from 'models/accounting.models'
import { formatDate, formatName } from 'lib/utils/Accounting/accounting.utils'
import { useAccountingContext } from 'containers/Accounting/AccountingContainer/AccountingContainer'
import { FileCardAlt } from 'components/Shared/FileCard/FileCard'
import FileValidationCard from '../FileValidationCard/FileValidationCard'
import './styles.scss'
import { ISydDocument } from 'models/shared.models'

interface IAccountingFileDropzoneContentMultipleProps<TState> {
  uploadItemId: number
  uploadedFiles: ISydDocument[]
  fileStatuses?: IAccountingFileStatus[]
  fileStatusesKey?: keyof TState
  filesToValidate?: ISydDocument[]
  openCommentsDialogKey?: keyof TState
  uploadedAndValidatedFiles?: ISydDocument[]
  updateState: (update: (draft: TState) => void) => void
}

const AccountingFileDropzoneContentMultiple = <TState,>({
  uploadItemId,
  uploadedFiles,
  fileStatuses,
  fileStatusesKey,
  filesToValidate,
  openCommentsDialogKey,
  uploadedAndValidatedFiles,
  updateState,
}: IAccountingFileDropzoneContentMultipleProps<TState>) => {
  const uploadedFile = uploadedFiles.find(
    file => file.idWsfile === uploadItemId
  )
  const fileToValidate = filesToValidate?.find(
    file => file.idWsfile === uploadItemId
  )
  const fileStatus = fileStatuses?.find(
    status => status.id === uploadItemId
  )?.status
  const uploadedAndValidatedFile = uploadedAndValidatedFiles?.find(
    file => file.idWsfile === uploadItemId
  )

  const toValidateOrValidatedFile = fileToValidate ?? uploadedAndValidatedFile

  const { handleFileDelete, handleFileDownload } = useAccountingContext()

  const updateFileStatuses =
    (key: keyof TState) => (value?: 'valid' | 'invalid') => {
      updateState(draft => {
        const fileStatuses = draft[key]

        if (Array.isArray(fileStatuses)) {
          ;(draft[key] as unknown as IAccountingFileStatus[]) =
            fileStatuses.map(status => {
              return status.id === uploadItemId
                ? { ...status, status: value }
                : status
            })
        }

        if (key === openCommentsDialogKey && value === 'invalid') {
          ;(
            draft as unknown as { clientCommentsDialog: boolean }
          ).clientCommentsDialog = true
        }
      })
    }

  return (
    <div className="accounting-file-dropzone-content-multiple-component">
      {uploadedFile && (
        <FileCardAlt
          key={uploadedFile.idWsfile}
          title={formatName(uploadedFile)}
          subtitle={formatDate()}
          type={'File'}
          onFileClick={() => handleFileDownload(uploadedFile)}
          actions={[
            {
              label: 'Renombrar archivo',
              action: () =>
                updateState(draft => {
                  ;(
                    draft as unknown as { selectedFile: ISydDocument }
                  ).selectedFile = uploadedFile
                }),
            },
            {
              label: 'Eliminar archivo',
              action: () => handleFileDelete(uploadedFile),
            },
          ]}
          error={uploadedFile.error}
          loading={uploadedFile.activity}
          className="file-zone"
        />
      )}
      {toValidateOrValidatedFile && fileStatusesKey && (
        <FileValidationCard
          variant="outlined"
          title={formatName(toValidateOrValidatedFile)}
          valid={fileStatus === 'valid'}
          invalid={fileStatus === 'invalid'}
          loading={toValidateOrValidatedFile.activity}
          onValidate={updateFileStatuses(fileStatusesKey)}
          onDownload={() => handleFileDownload(toValidateOrValidatedFile)}
          className="file-zone"
        />
      )}
    </div>
  )
}

export default AccountingFileDropzoneContentMultiple
